module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popularize"
  }, [_c('img', {
    staticClass: "top-banner",
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/others/banner1.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "separate-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "best-anchor"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/zhubo/1266964/"
    }
  }, [_c('img', {
    staticClass: "anchor-head",
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day1/有声的紫襟.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right-wrapper"
  }, [_c('a', {
    staticClass: "anchor-name",
    attrs: {
      "href": "http://www.ximalaya.com/zhubo/1266964/"
    }
  }, [_vm._v("有声的紫襟")]), _vm._v(" "), _c('div', {
    staticClass: "works-wrapper"
  }, [_c('a', {
    staticClass: "work",
    attrs: {
      "href": "http://www.ximalaya.com/1266964/album/4756811/"
    }
  }, [_c('img', {
    staticClass: "work-cover",
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day1/摸金天师.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "work-name"
  }, [_vm._v("摸金天师")])]), _vm._v(" "), _c('a', {
    staticClass: "work",
    attrs: {
      "href": "http://www.ximalaya.com/1266964/album/9877679/"
    }
  }, [_c('img', {
    staticClass: "work-cover",
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day1/狠人狠事.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "work-name"
  }, [_vm._v("狠人狠事")])]), _vm._v(" "), _c('a', {
    staticClass: "work",
    attrs: {
      "href": "http://www.ximalaya.com/1266964/album/8625924/"
    }
  }, [_c('img', {
    staticClass: "work-cover",
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day1/我当摸金校尉的那些年.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "work-name"
  }, [_vm._v("我当摸金校尉的那些年")])]), _vm._v(" "), _c('a', {
    staticClass: "work",
    attrs: {
      "href": "http://www.ximalaya.com/1266964/album/2991915/"
    }
  }, [_c('img', {
    staticClass: "work-cover",
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day1/武动乾坤.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "work-name"
  }, [_vm._v("武动乾坤")])]), _vm._v(" "), _c('a', {
    staticClass: "work",
    attrs: {
      "href": "http://www.ximalaya.com/1266964/album/3888524/"
    }
  }, [_c('img', {
    staticClass: "work-cover",
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day1/麻衣神算子.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "work-name"
  }, [_vm._v("麻衣神算子")])])]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("喜马拉雅FM超人气王牌主播，一个不好好当程序员的野生主播。声音磁性，演播方式多变，擅长恐怖悬疑类小说，在喜马拉雅已获得300多万粉丝，长期霸榜全球华语博客巅峰榜")])])]), _vm._v(" "), _c('div', {
    staticClass: "separate-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "top-anchors-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("- 他们都在这里 -")]), _vm._v(" "), _c('div', {
    staticClass: "top-anchors-row"
  }, [_c('div', {
    staticClass: "top-anchor"
  }, [_c('div', {
    staticClass: "top-anchor-top"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/zhubo/2342717/"
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day1/大斌.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "top-anchor-right"
  }, [_c('a', {
    staticClass: "anchor-name",
    attrs: {
      "href": "http://www.ximalaya.com/zhubo/2342717/"
    }
  }, [_vm._v("大斌")]), _vm._v(" "), _c('div', {
    staticClass: "works-wrapper"
  }, [_c('a', {
    staticClass: "work",
    attrs: {
      "href": "http://www.ximalaya.com/2342717/album/2684034/"
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day1/雪中悍刀行.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "work-name"
  }, [_vm._v("雪中悍刀行")])]), _vm._v(" "), _c('a', {
    staticClass: "work",
    attrs: {
      "href": "http://www.ximalaya.com/2342717/album/5363322/"
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day1/猎灵师.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "work-name"
  }, [_vm._v("猎灵师")])]), _vm._v(" "), _c('a', {
    staticClass: "work",
    attrs: {
      "href": "http://www.ximalaya.com/2342717/album/3551440/"
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day1/龙蛇演义.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "work-name"
  }, [_vm._v("龙蛇演义")])])])])]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("调频广播主持人、喜马拉雅签约白金主播，以其独特的风格、代入感广受受众喜爱")])]), _vm._v(" "), _c('div', {
    staticClass: "top-anchor"
  }, [_c('div', {
    staticClass: "top-anchor-top"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/zhubo/6333535/"
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day1/泡芙先生.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "top-anchor-right"
  }, [_c('a', {
    staticClass: "anchor-name",
    attrs: {
      "href": "http://www.ximalaya.com/zhubo/6333535/"
    }
  }, [_vm._v("泡芙先生")]), _vm._v(" "), _c('div', {
    staticClass: "works-wrapper"
  }, [_c('a', {
    staticClass: "work",
    attrs: {
      "href": "http://www.ximalaya.com/6333535/album/2696006/"
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day1/心理罪.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "work-name"
  }, [_vm._v("心理罪")])]), _vm._v(" "), _c('a', {
    staticClass: "work",
    attrs: {
      "href": "http://www.ximalaya.com/6333535/album/3131043/"
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day1/陈二狗的妖孽人生.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "work-name"
  }, [_vm._v("陈二狗的妖孽人生")])]), _vm._v(" "), _c('a', {
    staticClass: "work",
    attrs: {
      "href": "http://www.ximalaya.com/6333535/album/8215306/"
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day1/我混江湖的那些年.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "work-name"
  }, [_vm._v("我混江湖的那些年")])])])])]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("喜马拉雅签约主播。演绎风格独特，作品风格以悬疑灵异类以及都市类小说为主。其演播方式赢得广大听友的肯定和支持。在喜马拉雅FM已获得100万+粉丝，作品拥有超过5亿+的播放量与下载量。")])])]), _vm._v(" "), _c('div', {
    staticClass: "top-anchors-row"
  }, [_c('div', {
    staticClass: "top-anchor"
  }, [_c('div', {
    staticClass: "top-anchor-top"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/zhubo/2642819/"
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day1/章鱼讲故事.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "top-anchor-right"
  }, [_c('a', {
    staticClass: "anchor-name",
    attrs: {
      "href": "http://www.ximalaya.com/zhubo/2642819/"
    }
  }, [_vm._v("章鱼讲故事")]), _vm._v(" "), _c('div', {
    staticClass: "works-wrapper"
  }, [_c('a', {
    staticClass: "work",
    attrs: {
      "href": "http://www.ximalaya.com/2642819/album/2688124/"
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day1/罗布泊之咒.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "work-name"
  }, [_vm._v("罗布泊之咒")])]), _vm._v(" "), _c('a', {
    staticClass: "work",
    attrs: {
      "href": "http://www.ximalaya.com/2642819/album/425648/"
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day1/无证之罪.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "work-name"
  }, [_vm._v("无证之罪")])]), _vm._v(" "), _c('a', {
    staticClass: "work",
    attrs: {
      "href": "http://www.ximalaya.com/2642819/album/3969624/"
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day1/我是阴阳人.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "work-name"
  }, [_vm._v("我是阴阳人")])])])])]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("演播风格层次分明，逻辑清晰，很容易将人带入情境，画面感非常强。对人物角色把握到位，人物对话辨识感很强")])]), _vm._v(" "), _c('div', {
    staticClass: "top-anchor"
  }, [_c('div', {
    staticClass: "top-anchor-top"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/zhubo/4932085/"
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day1/丸子.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "top-anchor-right"
  }, [_c('a', {
    staticClass: "anchor-name",
    attrs: {
      "href": "http://www.ximalaya.com/zhubo/4932085/"
    }
  }, [_vm._v("丸子")]), _vm._v(" "), _c('div', {
    staticClass: "works-wrapper"
  }, [_c('a', {
    staticClass: "work",
    attrs: {
      "href": "http://www.ximalaya.com/4932085/album/3160816/"
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day1/超品相师.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "work-name"
  }, [_vm._v("超品相师")])]), _vm._v(" "), _c('a', {
    staticClass: "work",
    attrs: {
      "href": "http://www.ximalaya.com/4932085/album/2760075/"
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day1/风水鬼师.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "work-name"
  }, [_vm._v("风水鬼师")])]), _vm._v(" "), _c('a', {
    staticClass: "work",
    attrs: {
      "href": "http://www.ximalaya.com/4932085/album/2799378/"
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day1/校花的贴身高手.jpg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "work-name"
  }, [_vm._v("校花的贴身高手")])])])])]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("喜马拉雅FM人气主播，小说演播者，网红，游戏设计师。主播丸子于2014年至今，演播了多部多类型的网络有声小说。喜马拉雅FM粉丝破100万，播放量以及下载量近8亿，演播风格独具一格。")])])])]), _vm._v(" "), _c('div', {
    staticClass: "separate-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "more-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("- 了解更多 -")]), _vm._v(" "), _c('div', {
    staticClass: "links-wrapper"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'classic'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/others/经典汇聚@2x.png")
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'workLib'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/others/海量作品@2x.png")
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'benefits'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/others/福利体系@2x.png")
    }
  })])], 1)]), _vm._v(" "), _c('router-link', {
    staticClass: "btn-join-bottom",
    attrs: {
      "to": {
        name: 'anchorIndex'
      }
    }
  }, [_vm._v("立即加入")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn-join-fixed",
    attrs: {
      "to": {
        name: 'anchorIndex'
      }
    }
  }, [_vm._v("立即加入")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-context"
  }, [_c('p', [_vm._v("有声的紫襟、大斌、章鱼讲故事，这些你爱的声音创作者都来自喜马拉雅作品有声化平台，从默默无名的有声爱好者，慢慢成长拥有百万粉丝的主播大神")]), _vm._v(" "), _c('p', [_vm._v("加入我们，下一个大神也许就是你……")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8370082e!./~/vue-loader/lib/selector.js?type=template&index=0!./views/popularize/Idols.vue
// module id = 1103
// module chunks = 0